module.exports = __webpack_public_path__ + "static/media/arrow-right-black.f22400e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/arrow-right-black.svg
// module id = 1164
// module chunks = 0